import React, { FC } from 'react';

import { CollapsePanelProps } from './types';

import { Panel as StyledPanel } from './styled';

import Header from '../Header';

const Panel: FC<CollapsePanelProps> = ({
  header,
  description,
  stopHeaderPropagation,
  ...props
}) => (
  <StyledPanel
    {...props}
    withdescription={!!description}
    header={
      <Header header={header} description={description} stopPropagation={stopHeaderPropagation} />
    }
  />
);

export default Panel;
